export default __webpack_public_path__ + "static/gamerize-3-a-5cd9cb8a23c14c3f97b1d9ecb973a56d.webp";